import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-color-surface md:p-(--container-spacing)',

    banner: 'relative',
    bannerTitleWrapper: 'absolute right-0 bottom-5 left-0 w-full md:px-5',
    bannerTitle: 'heading-s w-full border-t-1 border-b-1 py-1.5 uppercase',
    bannerTitleContainer: 'flex gap-10 px-5 md:gap-40 md:px-20',

    content: ['flex gap-6 max-md:flex-col md:items-end md:gap-18.5', 'p-5 max-md:py-8'],

    formTitle: 'flex flex-col items-center md:mb-2',
    formTitleFirstLine: 'heading-3xl md:heading-2xl-desk leading-none! uppercase',
    formTitleSecondLine: 'heading-italic-l md:heading-italic-xl',
    form: 'lg:w-[500px]'
  },
  variants: {
    theme: {
      light: {
        bannerTitle: 'text-white'
      },
      dark: {
        bannerTitle: 'text-black'
      }
    }
  },
  defaultVariants: {}
});
